module.exports = new __parcel__URL__("desktop.a16d3532.glb").toString();